<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div class="center">
    <button @click="active = !active">active</button>
    <vs-dialog not-close auto-width not-padding v-model="active">
      <div class="con-image">
        <img src="/foto1.png" alt="" />
      </div>
    </vs-dialog>
  </div>
</template>

<template>
  <div id="data-participants-list-view" class="data-list-container">
    <div id="search-component">
      <div class="container-select">
        <select
          id="recording-search-type"
          name="recording-search-type"
          v-model="searchType"
        >
          <option
            class="option"
            v-for="(item, index) in searchTypes"
            :key="index"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
      </div>
      <template v-if="searchType !== 'gender'">
        <!-- input search -->
        <vs-input
          class="text-search-input w-full"
          v-model="searchTerms"
          id="text-search-input"
          name="text-search-input"
          :type="searchType === 'name' ? 'text' : 'number'"
          @keyup="updateSearchString"
          v-validate="{ required: false }" />
        <div
          class="absolute right-0 z-50"
          v-show="searchType !== 'neighborhood'"
        >
          <feather-icon
            :class="{ hidden2: !searchTerms }"
            icon="XIcon"
            class="px-4 cursor-pointer close-search-icon"
            @click="updateSearchParams(true)"
          /></div
      ></template>
      <select
        v-else
        id="recording-search-type"
        name="recording-search-type"
        v-model="searchTerms"
        @change="updateSearchString"
      >
        <option
          class="option"
          v-for="(item, index) in gendersList"
          :key="index"
          :value="item.value"
          :class="{ inactive: item.value === null }"
          :disabled="item.value === null"
        >
          {{ item.text }}
        </option>
      </select>
    </div>

    <!-- fields list modal -->
    <vs-prompt
      class="active-fields-modal"
      title="Campos Ativos"
      accept-text="OK"
      :active.sync="activeFieldsModal"
    >
      <div
        v-for="item in availableFields"
        :key="item.name"
        class="active-fields-item"
        :class="{ default: item.default, active: item.active }"
      >
        <vs-switch
          :id="'custom-input-' + item.name"
          class="active-fields-btn"
          :class="{ default: item.default, active: item.active }"
          icon-pack="feather"
          v-model="item.active"
        />
        <span
          class="active-fields-text"
          :class="{ default: item.default, active: item.active }"
          >{{ item.text }}</span
        >
      </div>
    </vs-prompt>
    <!-- fields list modal -->

    <!-- Share modal -->
    <vs-prompt
      class="active-fields-modal"
      title="Compartilhar link"
      accept-text="OK"
      :active.sync="shareModal"
    >
      <social-sharing
        :url="urlToShare"
        title="SBT Caravanas"
        description="Cadastre-se na minha lista de contatos"
        quote="Para participar das gravações"
        hashtags="sbtcaravanas, sbt"
        inline-template
      >
        <div>
          <vs-row class="mt-3">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
            >
              <network network="whatsapp">
                <feather-icon
                  icon="MessageCircleIcon"
                  svgClasses="h-4 w-4"
                />Whatsapp
              </network>
            </vs-col>
          </vs-row>
        </div>
      </social-sharing>
    </vs-prompt>

    <div id="data-cardlist-list">
      <div
        class="flex flex-wrap-reverse items-center flex-grow justify-between cardlist-content"
        id="participants-cardlist"
      >
        <div
          class="btn-active-fields p-2 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          @click="openShareModal"
        >
          <feather-icon
            icon="Share2Icon"
            svgClasses="h-4 w-4"
            style="margin-right: 4px"
          />
          Compartilhar
        </div>
        <input
          id="urlToShare"
          type="hidden"
          :value="urlToShare"
          :class="{ done: urlToShare }"
        />
        <div
          class="btn-active-fields p-2 ml-3 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          @click="copyToClipboard"
        >
          <feather-icon
            icon="CopyIcon"
            svgClasses="h-4 w-4"
            style="margin-right: 4px"
          />
          Copiar link
        </div>
      </div>

      <div class="no-records" v-if="loadedData && participants.length === 0">
        <p>Não há dados disponíveis</p>
      </div>
      <vs-card
        style="margin: 3px 0; border: 1px solid #ddd"
        class="cardlist-data container"
        :key="indextr"
        v-for="(tr, indextr) in participants"
        :id="'participant-' + tr.id"
      >
        <vs-row>
          <div class="public-card-container">
            <div class="contact-photo-container" :class="'cardlist-item-'">
              <img :src="tr.photo" />
            </div>

            <div class="public-description-container">
              <div class="cardlist-item item-title">
                <span class="public-name">{{
                  tr.name + " " + tr.surname
                }}</span>
                <span class="public-age"
                  >, {{ tr.birthdate | formatBirthdate }}</span
                >
              </div>
              <div class="cardlist-item">
                <span class="item-title">Telefone:</span>
                <span class="item-text">{{ tr.mobile | formatMobile }}</span>
              </div>

              <div class="cardlist-item">
                <span class="item-title">Gênero:</span>
                <span class="item-text">{{ tr.gender | formatGender }}</span>
              </div>

              <div class="cardlist-item" :class="{ hidden2: !tr.specialNeed }">
                <span class="item-title">Necessidades especiais:</span>
                <span class="item-text">{{ tr.specialNeed }}</span>
              </div>
            </div>
            <div class="trash-container">
              <feather-icon
                class="cursor-pointer"
                icon="TrashIcon"
                :svgClasses="[
                  'hover:text-dark',
                  {
                    'h-10 w-10': isMobile,
                    'h-8 w-8': !isMobile,
                  },
                ]"
                @click="remove(tr)"
              />
            </div>
          </div>
        </vs-row>
      </vs-card>
    </div>

    <pagination
      style="margin: 30px 0 70px 0"
      :totalPages="totalPageCount"
      :currentPage="currentPage"
      :isWorking="isWorking"
      :onPageChange="handleChangePage"
      :totalContacts="totalPages"
    />
  </div>
</template>

<script>
import Vue from "vue";
import moduleParticipant from "@/store/participant/moduleParticipant.js";
import SocialSharing from "vue-social-sharing";
import pagination from "@/components/pagination.vue";
import axios from "@/axios.js";
import { Plugins } from "@capacitor/core";
const { Share } = Plugins;

export default {
  components: {
    pagination,
    SocialSharing,
  },
  data() {
    return {
      active: true,
      loadedData: false,
      isWorking: true,
      selected: [],
      currentPage: 1,
      itemsPerPage: 10,
      offset: 0,
      isMounted: false,
      activePrompt: false,
      activeFieldsModal: false,
      shareModal: false,
      availableFields: [
        { name: "photo", text: "-", active: true, default: false },
        { name: "name", text: "Nome", active: true, default: true },
        { name: "mobile", text: "Celular", active: true, default: true },
        { name: "gender", text: "Gênero", active: true, default: true },
        { name: "birthdate", text: "Idade", active: true, default: true },
      ],
      searchTimer: 0,
      searchType: "name",
      searchTerms: "",
      searchTypes: [
        { value: null, text: "Filtrar por" },
        { value: "name", text: "Filtrar por Nome" },
        { value: "age", text: "Filtrar por Idade Mínima" },
        { value: "gender", text: "Filtrar por Gênero" },
      ],
      gendersList: [
        { value: 0, text: "Todos" },
        { value: "feminine", text: "Feminino" },
        { value: "male", text: "Masculino" },
        { value: "others", text: "Outros" },
      ],
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.windowWidth < 420;
    },
    caravanistLogged() {
      return this.$store.state.AppActiveUser || {};
    },
    urlToShare() {
      let locationOrigin = location.origin.includes("localhost")
        ? "https://caravanas-pwa.sbtlab.io"
        : location.origin;

      return `${locationOrigin}/participante/${
        this.caravanistLogged.uuid
      }?name=${encodeURI(this.caravanistLogged.name)}`;
    },
    activeFields() {
      return this.availableFields.filter((item) => {
        return item.active;
      });
    },
    totalPageCount() {
      const totalItems = this.$store.state.participant.totalItems || 0;
      const itemsPerPage = this.itemsPerPage || 10;

      const increased = totalItems % itemsPerPage > 0;

      let totalPages = parseInt(totalItems / itemsPerPage) || 0;
      if (increased) {
        totalPages++;
      }

      return totalPages || 0;
    },
    totalPages() {
      return this.$store.state.participant.totalItems;
    },
    participants() {
      return this.$store.state.participant.participants;
    },
  },
  methods: {
    updateSearchString(evt) {
      if (evt) {
        evt = evt && (evt.which || evt.keyCode) ? evt : window.event;
        const charCode = evt.which ? evt.which : evt.keyCode;

        if (
          ![8, 13, 32, 46].includes(charCode) &&
          !(charCode > 90 || charCode < 65) &&
          !/\w|\d/g.test(charCode)
        ) {
          return;
        }
      }

      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.handleChangePage(1, true);
      }, 650);
    },
    updateSearchParams(shouldReset = false) {
      clearTimeout(this.searchTimer);
      if (shouldReset === true) {
        if (this.searchTerms) {
          if (this.searchType !== "gender") {
            this.searchTerms = null;
          } else {
            this.searchTerms = 0;
          }
        }
      } else if (shouldReset === 1) {
        if (!this.searchTerms) {
          return;
        }
      }

      this.searchTimer = setTimeout(() => {
        this.handleChangePage(1, true);
      }, 50);
    },
    handleChangePage(page, isSearch = true) {
      if (this.isWorking) return;

      page = +page || 1;
      if (page > this.totalPageCount) page = this.totalPageCount;

      let filters = undefined;
      const searchType = this.searchType;
      if (isSearch === true) {
        let searchTerms = ((this.searchTerms || "") + "").trim();
        if (
          (searchType === "age" && +searchTerms > 0) ||
          !searchTerms ||
          searchTerms.length > 2
        ) {
          if (searchTerms) {
            filters = {
              [this.searchType]: searchTerms,
            };
          }
        } else {
          return;
        }
      }

      if (this.isMounted) {
        this.setLoading(true);
      }

      if (page < 1) {
        page = 1;
      }

      this.currentPage = +page;

      // console.log("handleChangePage", page, filters);

      this.offset += this.itemsPerPage;

      this.$store
        .dispatch("participant/fetchParticipants", {
          filters,
          limit: this.itemsPerPage,
          offset: (page - 1) * this.itemsPerPage,
          order: this.activeSort,
        })
        .finally(() => {
          this.setLoading(false);
          window.scrollBy(0, -window.innerHeight);
          this.loadedData = true;
        });
    },
    loadMore() {
      this.isWorking = true;
      this.setLoading(true);

      this.offset += this.itemsPerPage;

      this.$store
        .dispatch("participant/fetchParticipants", {
          limit: this.itemsPerPage,
          offset: this.offset,
        })
        .finally(() => {
          this.setLoading(false);
          if (
            this.participants.length !== 0 &&
            this.participants.length % this.itemsPerPage === 0 &&
            this.totalItems > this.participants.length
          ) {
            window.scrollBy(0, -window.innerHeight);
            this.isWorking = false;
          }
        });
    },
    remove(participant) {
      const { name, surname } = participant;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Remover contato`,
        text: `Deseja remover o contato "${name + " " + surname}".`,
        acceptText: "Remover",
        cancelText: "Cancelar",
        accept: () => {
          this.setLoading(true);
          this.$store
            .dispatch("participant/removeFromCaravanist", participant.id)
            .finally(() => {
              this.setLoading(false);
            });
        },
      });
    },
    copyToClipboard() {
      this.$copyText(this.urlToShare);
      this.$vs.notify({
        text: "Link copiado!",
        color: "primary",
        iconPack: "feather",
        icon: "favorite",
        time: 4000,
        position: "bottom-left",
      });
    },
    getClass(item) {
      switch (item) {
        case "gender":
        case "birthdate":
          return "half";
        default:
          break;
      }
      return "";
    },
    openFieldsModal() {
      this.activeFieldsModal = true;
    },
    openShareModal() {
      Share.share({
        title: "SBT Caravanas",
        text: "Cadastre-se na minha lista de contatos",
        url: this.urlToShare,
      })
        .then(() => console.log("Successful share"))
        .catch((error) => (this.shareModal = true));
    },
    deleteData(id) {
      this.$store.dispatch("dataList/removeItem", id).catch((err) => {
        console.error(err);
      });
    },
    getStatusColor(status) {
      return !status ? "danger" : "success";
    },
    setLoading(value, container = "#data-cardlist-list") {
      this.isWorking = value === true;
      if (this.isWorking) {
        this.$vs.loading({
          container,
          scale: 0.6,
        });
      } else {
        this.$vs.loading.close(`${container} .con-vs-loading`);
      }
    },
  },
  filters: {
    formatBirthdate: function (date) {
      if (!date) return;
      let today = new Date();
      let birthDate = new Date(date);
      let age = today.getFullYear() - birthDate.getFullYear();
      let m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age = age - 1;
      }

      return age + " anos";
    },
    formatTime: function (time) {
      if (!time) return;
      return time.replace(":00", "");
    },
    formatMobile: (value) => {
      if (!value) return "";
      return value.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    },
    formatGender: (value) => {
      if (!value) return "";
      switch (value) {
        case "male":
          return "Masculino";
        case "female":
        case "feminine":
          return "Feminino";
        default:
          return "Outros";
      }
    },
  },
  created() {
    if (!moduleParticipant.isRegistered) {
      this.$store.registerModule("participant", moduleParticipant);
      moduleParticipant.isRegistered = true;
    }

    this.$store.commit("participant/CLEAR_PARTICIPANTS");

    this.offset = 0;
    this.setLoading(false);
    this.handleChangePage();
  },
  mounted() {
    this.isMounted = true;
    this.setLoading(true);
  },
};
</script>

<style lang="scss">
.public-card-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.public-description-container {
  padding-left: 6px;
  display: flex;
  flex: 1;
  flex-direction: column;
}
.trash-container {
  display: flex;
  width: 30px;
  align-items: center;
}

.public-age {
  font-weight: normal !important;
}
.public-name {
  font-weight: bolder !important;
  color: #000 !important;
}
.contact-photo-container {
  width: 53px;
}

.contact-photo-container img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #eee;
  margin: 5px 0;
  object-fit: cover;
}

#participants-cardlist {
  .data-list-btn-container {
    width: auto;
  }
}
#data-participants-list-view {
  .item-title {
    margin-right: 5px;
  }
}

.vx-navbar-wrapper {
  z-index: 50999;
}

#search-component {
  position: relative;
  z-index: 50998;
  max-width: calc(100% - 300px);
  margin: 0 auto -24px auto;
  display: flex;
  .con-select {
    max-width: 200px;
    margin-top: 0 !important;
    & ~ .con-select,
    & ~ .vs-component,
    & ~ .vdp-datepicker {
      width: 100%;
      max-width: 100%;
      margin-left: 12px;
    }
  }
  .z-50 {
    top: 6px;
    height: 35px;
  }
}

.hidden2 {
  visibility: hidden;
}

.vue-back-to-top {
  bottom: 10% !important;
}

@media screen and (min-width: 640px) {
  #custom-pagination {
    &.offset-top {
      margin-top: 41px;
      margin-bottom: 9px;
    }
  }
  #data-cardlist-list {
    margin-top: -94px;
    .cardlist-content {
      margin-bottom: 60px;
    }
  }
}

@media screen and (max-width: 768px) {
  #data-cardlist-list {
    margin-top: 20px;
    .cardlist-data {
      padding-left: 0;
      padding-right: 0;
    }
  }
}

@media screen and (max-width: 767px) {
  #search-component {
    margin: 0 auto 20px auto;
    max-width: 100%;
    display: block;

    .con-select,
    .vs-component {
      min-width: 100%;
      margin: 12px 0 0 0;
      & + .con-select,
      & + .vs-component {
        margin: 12px 0 0 0 !important;
      }
    }
    .z-50 {
      top: 57px;
    }
  }
}
.container-select {
  width: 50%;
  margin-right: 20px;
  @media (max-width: 768px) {
    width: 100%;
    margin: 0;
  }
}
.con-image {
  border-radius: inherit;
}
.con-image img {
  display: block;
  position: relative;
  border-radius: inherit;
  max-width: 350px;
}
</style>
